import type React from "react"
import { Modal, Button, Row, Col } from "react-bootstrap"
import { CheckCircle } from "lucide-react"

interface SuccessModalProps {
  show: boolean
  onHide: () => void
  message: string
}

const SuccessModal: React.FC<SuccessModalProps> = ({ show, onHide, message }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="py-5">
        <Row className="align-items-center">
          <Col xs={12} className="text-center">
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 10
          }}
          >
            <CheckCircle className="text-success mb-3" size={32} style={{
            marginTop: 10
            }}
             />
            <h4>{message}</h4>
            </div>
            <Button variant="primary" onClick={onHide} className="mt-4">
              Close
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default SuccessModal

